import * as React from 'react';

import { cn } from '@/lib/utils';

function Input({ className, type, ...props }: Readonly<React.ComponentProps<'input'>>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'flex h-[var(--input-height)] w-full min-w-0 rounded-[var(--input-radius)] border border-[var(--input-border)] bg-[var(--input-background)] px-3 py-1 text-[length:var(--input-font-size)] text-[var(--input-foreground)] placeholder:text-[var(--input-placeholder)] transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-[length:var(--small-font-size)] file:font-medium hover:border-[var(--input-border-hover)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        'focus-visible:border-[var(--input-border-focus)] focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-destructive/20 aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
